<template>
    <div style="width:100%;">
          <Loading :value="loading" ></Loading>
            <!-- <v-layout row>
                <v-flex xs4 mt-2 mb-2 mr-2 ml-2 >
                     <v-card   color="cyan darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs8>
                                            <div>
                                            <div class="display-3">{{coutPrevu}}</div>
                                            <div>Coût prévisionnel</div>
                                            </div>
                                        </v-flex>
                                         <v-flex xs4>
                                            <div></div>
                                            <div class="display-3"></div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>

                 <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                    <v-card   color="green darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs8>
                                            <div>
                                            <div class="display-3">{{coutActuel}}</div>
                                            <div>Coût actuel</div>
                                            </div>
                                        </v-flex>
                                         <v-flex xs4>
                                            <div></div>
                                            <div class="display-3"></div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>



                <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                     <v-card   color="light-blue darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs7>
                                            <div>
                                            <div class="headline">{{nbOuvrier}}</div>
                                            <div>Ouvriers</div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs5>
                                            <div>Prestataires</div>
                                            <div class="display-3">{{nbPrestataire}}</div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>
        </v-layout> -->

        <v-layout row>



                <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                     <v-card   color="purple darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs8>
                                            <div>
                                            <div>Taux exécution chronogramme (%)</div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs5>
                                            <div class="display-3">{{tauxExec}}</div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>

                <v-flex xs8  mt-2 mb-2 mr-2 ml-2  >
                         <v-card   color="orange darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs7>
                                            <div>
                                                <div class="headline">{{nbTrxTermine}}</div>
                                                <div>Travaux Terminés</div>
                                            </div>
                                             <div>
                                                <div class="headline">{{nbTrxArret}}</div>
                                                <div>Travaux Arretés</div>
                                            </div>
                                             <div>
                                                <div class="headline">{{nbTrxEnCours}}</div>
                                                <div>Travaux (en cours)</div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs5>
                                            <div>Total travaux </div>
                                            <div class="display-3">{{nbTrx}} </div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>


        </v-layout>
    </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";

import Loading from "@/components/Loading";


export default {
  components: { Loading },
  name: "WidgetChantier",
  props: {
    show: {
      type: Boolean
    },
    type:{
        type:Number,
        default: 0
    },
    chantier: {
      type: Object
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      loading: false,

       statusRapport: [],
       coutPrevu:0,
       coutActuel:0,
       nbOuvrier:0,
       nbPrestataire: 0,
       nbTrxTermine:0,
       nbTrxArret:0,
       nbTrxEnCours: 0,
       nbTrx: 0,
       tauxExec:0



    };
  },

  watch: {

  },


  methods: {
      loadStatChantTrx(){

        let url = this.domaine + "chantier/stat/"+this.chantier.idChant;

        this.$http.get(url).then( (response)=>{
        this.loading = false;
        this.coutPrevu = response.body.coutPrevu;
        this.coutActuel = response.body.coutActuel;
        this.nbOuvrier = response.body.nbOuvrier;
        this.nbPrestataire = response.body.nbPrestataire;
        this.nbTrxTermine = response.body.nbTrxTermine;
        this.nbTrxArret = response.body.nbTrxArret;
        this.nbTrxEnCours = response.body.nbTrxEnCours;
        this.nbTrx = response.body.nbTrx;
        this.tauxExec = response.body.tauxExec;
       }, (error)=>{
            this.loading = false;
        } )
    }
  },

  watch: {
      chantier: function(newValue, oldValue){
             if(this.chantier.idChant != null){
                  this.loadStatChantTrx()
             }else {
             }

      }
  },


  mounted() {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/boardChantier/widgetChantier.vue